import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { UpdateCampaignLaunchSchema } from "schema"
import { z } from "zod"
import { getCampaignQueryKey } from "../lib/campaignQuery"

type Props = z.input<typeof UpdateCampaignLaunchSchema> & {
  launchId: string
}

export function useUpdateCampaignLaunchMutation(campaignId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ launchId, ...data }: Props) => {
      return axios.patch(`/campaigns/${campaignId}/launches/${launchId}`, data)
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(campaignId) }),
  })
}
